export const RRS_MICROLOAN = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Slik fungerer mikrolan',
  url: 'https://scoopr.no/slik-fungerer-mikrolan',
  description:
    'Mikrolån er en dårlig idé fordi det ofte koster mer i renter og gebyrer enn forbrukslån og kredittkort.',
  datePublished: '2022-02-10T08:00:00+00:00',
  dateModified: '2022-02-10T08:00:00+00:00',
};
